import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../axios';
import {Container, Form, FormBtn, FormCover, H1, H3, MediumSpacing} from "../../styles";

const ClassUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [number, setNumber] = useState('');
    const [semester, setSemester] = useState('');
    const [course, setCourse] = useState('');
    const [lecturer, setLecturer] = useState('');
    const [semesters, setSemesters] = useState([]);
    const [courses, setCourses] = useState([]);
    const [lecturers, setLecturers] = useState([]);

    useEffect(() => {
        axios.get(`/classes/${id}/`)
            .then(response => {
                const classData = response.data;
                setNumber(classData.number);
                setSemester(classData.semester);
                setCourse(classData.course);
                setLecturer(classData.lecturer);
            })
            .catch(error => console.error("There was an error fetching the class data!", error));

        axios.get('/semesters/')
            .then(response => setSemesters(response.data))
            .catch(error => console.error("There was an error fetching the semesters!", error));

        axios.get('/courses/')
            .then(response => setCourses(response.data))
            .catch(error => console.error("There was an error fetching the courses!", error));

        axios.get('/lecturers/')
            .then(response => setLecturers(response.data))
            .catch(error => console.error("There was an error fetching the lecturers!", error));
    }, [id]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const updatedClass = {
            number: parseInt(number, 10),
            semester: semester,
            course: course,
            lecturer: lecturer // Send lecturer as a single ID
        };

        console.log("Submitting:", updatedClass); // Debugging line

        axios.put(`/class/update/${id}/`, updatedClass)
            .then(response => {
                console.log(response.data);
                navigate('/classes'); // Redirect to the classes list
            })
            .catch(error => {
                console.error("There was an error updating the class!", error.response.data);
                console.log(error.response.data); // Log the entire response
            });
    };

    return (
        <Container>
            <FormCover>
            <H3>Update Class</H3>
                                <MediumSpacing/>

            <Form onSubmit={handleSubmit}>
                <div>
                    <label>Number:</label>
                    <br/>
                    <input
                        type="number"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        required
                    />
                </div>
                                <MediumSpacing/>

                <div>
                    <label>Semester:</label>
                    <br/>
                    <select
                        value={semester}
                        onChange={(e) => setSemester(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select Semester</option>
                        {semesters.map(sem => (
                            <option key={sem.id} value={sem.id}>
                                Semester {sem.semester} - {sem.year}
                            </option>
                        ))}
                    </select>
                </div>
                <MediumSpacing/>
                <div>
                    <label>Course:</label>
                    <br/>
                    <select
                        value={course}
                        onChange={(e) => setCourse(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select Course</option>
                        {courses.map(crs => (
                            <option key={crs.id} value={crs.id}>
                                {crs.name}
                            </option>
                        ))}
                    </select>
                </div>
                                <MediumSpacing/>

                <div>
                    <label>Lecturer:</label>
                    <br/>
                    <select
                        value={lecturer}
                        onChange={(e) => setLecturer(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select Lecturer</option>
                        {lecturers.map(lec => (
                            <option key={lec.lecturer_id} value={lec.lecturer_id}>
                                {lec.first_name} {lec.last_name}
                            </option>
                        ))}
                    </select>
                </div>
                <FormBtn type="submit">Update Class</FormBtn>
            </Form>
                </FormCover>
        </Container>
    );
};

export default ClassUpdate;
